var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.reg.descricao)+" \""),_c('a',[_vm._v(_vm._s(_vm.reg.obj.descricao))]),_vm._v("\" "),_c('u-icon',{attrs:{"name":"envelope","type":"fa","icon-style":"light"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }